import { Model } from 'survey-core';
import styled from 'styled-components';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Goals } from '../quiz/goals';
import { Gender } from '../quiz/gender';
import { Physiology } from '../quiz/physiology';
import { Age } from '../quiz/age';

const DevToolContainer = styled.div`
  position: fixed;
  left: 40px;
  top: 40px;
  width: 300px;
  height: 300px;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  padding: 10px;
`;

export function DevTool({ survey }: { survey: Model }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const [goal, setGoal] = useState(survey.getValue('goals'));
  const [gender, setGender] = useState(survey.getValue('gender'));
  const [physiology, setPhysiology] = useState(survey.getValue('physiology'));
  const [age, setAge] = useState(survey.getValue('age'));

  const handleGoalChange = useCallback((e: any) => {
    survey.setValue('goals', e.target.value);
    setGoal(e.target.value);
  }, []);

  const handleGenderChange = useCallback((e: any) => {
    survey.setValue('gender', e.target.value);
    setGender(e.target.value);
  }, []);

  const handlePhysiologyChange = useCallback((e: any) => {
    survey.setValue('physiology', e.target.value);
    setPhysiology(e.target.value);
  }, []);

  const handleAgeChange = useCallback((e: any) => {
    survey.setValue('age', e.target.value);
    setAge(e.target.value);
  }, []);

  useEffect(() => {
    (window as any).toggleDevTools = () => {
      setIsExpanded(e => !e);
    };
  }, []);

  const visibleForHosts = ['localhost', 'quiz3.builtwithscience.com'];
  if (!isExpanded || !visibleForHosts.includes(window.location.hostname)) {
    return null;
  }

  return (
    <DevToolContainer>
      {isExpanded && (
        <div>
            Update answers:
            <div>
                Goal:
                <select onChange={handleGoalChange} value={goal}>
                    <option value={Goals.LoseFat}>Lose fat and get lean</option>
                    <option value={Goals.BuildMuscle}>Build muscle and strength</option>
                    <option value={Goals.BuildMuscleAndLoseFat}>Burn fat and build muscle</option>
                </select>
            </div>
            <div>
                Gender:
                <select onChange={handleGenderChange} value={gender}>
                    <option value={Gender.Male}>Male</option>
                    <option value={Gender.Female}>Female</option>
                    <option value={Gender.NonBinary}>Non-binary</option>
                </select>
            </div>
            <div>
                Physiology:
                <select onChange={handlePhysiologyChange} value={physiology}>
                    <option value={Physiology.Male}>Male</option>
                    <option value={Physiology.Female}>Female</option>
                </select>
            </div>
            <div>
                Age:
                <select onChange={handleAgeChange} value={physiology}>
                    <option value={Age.Teens}>&lt; 20</option>
                    <option value={Age.Twenties}>20-29</option>
                    <option value={Age.Thirties}>30-39</option>
                    <option value={Age.Fourties}>40-49</option>
                    <option value={Age.OverFifty}>50+</option>
                </select>
            </div>
        </div>
      )}
    </DevToolContainer>
  );
}
